import { render, staticRenderFns } from "./universities.vue?vue&type=template&id=73270cea&"
import script from "./universities.vue?vue&type=script&lang=js&"
export * from "./universities.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports